/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Show_Hide_TimelineInputs */



/**
* | output |
* | --- |
* | "Show/Hide Timeline" |
*
* @param {Show_Hide_TimelineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const show_hide_timeline = /** @type {((inputs?: Show_Hide_TimelineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_Hide_TimelineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher/Masquer la ligne de temps")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitleiste ein-/ausblenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra/Nascondi cronologia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать/скрыть временную шкалу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar/ocultar la línea de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示/隐藏时间线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムラインの表示/非表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमलाइन दिखाएँ/छिपाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar/Ocultar Linha do Tempo")
	return /** @type {LocalizedString} */ ("Show/Hide Timeline")
});